const UseSetterNodeError = (currentNode, tabName, fieldName, error) => {

    if (!currentNode.data.form) {
        currentNode.data.form = {}
    }

    if (!currentNode.data.form.tabs) {
        currentNode.data.form.tabs = {}
    }

    if (!currentNode.data.form.tabs[tabName]) {
        currentNode.data.form.tabs[tabName] = {}
    }

    if (!currentNode.data.form.tabs[tabName].fields) {
        currentNode.data.form.tabs[tabName].fields = {}
    }

    if (!currentNode.data.form.tabs[tabName].fields[fieldName]) {
        currentNode.data.form.tabs[tabName].fields[fieldName] = {}
    }

    currentNode.data.form.tabs[tabName].fields[fieldName].error = error


    return currentNode
}

export default UseSetterNodeError

